import React from 'react';
import styles from './Styles/hand.module.css';
import Card from './Card';

type HandProps = {
    title: string,
    cards: any[]
  };
  
  const Hand: React.FC<HandProps> = ({ title, cards }) => {
    const getTitle = () => {
      if (cards.length > 0) {
        return (
          <h1 className={styles.title}>{title}</h1>
        );
      }
    }
    return (
    <div className="game">
      <div className={styles.handContainer}>
        {getTitle()}
        <div className={styles.cardContainer}>
          {cards.map((card: any, index: number) => {
            return (
              <Card key={index} value={card.value} suit={card.suit} hidden={card.hidden} />
            );
          })}
        </div>
      </div>
     </div>
    );
  }
  
  export default Hand;